import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5001/api';

const api = axios.create({
  baseURL: baseURL,
  timeout: 300000, // 5分钟超时，支持大文件上传
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 优先检查学校平台的token
    const schoolToken = localStorage.getItem('school_token');
    if (schoolToken) {
      config.headers.Authorization = `Bearer ${schoolToken}`;
    } else {
      // 否则使用后台管理平台的token
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;